import {
  AnimationPlayer,
  BackgroundTokens,
  Box,
  Breakpoint,
  Button,
  Image,
  useBreakpoint,
  useBreakpointProp,
} from '@bonanza-social/moonlight';
import { memo, useCallback, useEffect, useState } from 'react';
import animations from '../assets/animations';
import { StackNavigationProp, Screen, useNavigation } from '@bonanza-social/navigation';
import {
  Easing,
  useAnimatedStyle,
  useSharedValue,
  withRepeat,
  withTiming,
} from 'react-native-reanimated';

function ShopMysteryBoxScreen() {
  const navigation =
    useNavigation<StackNavigationProp<AppNavigatorParamsList>>();

  const breakpoint = useBreakpoint();
  const isMobile = breakpoint === Breakpoint.MOBILE;

  const [showAnimation, setShowAnimation] = useState(isMobile);

  const [opening, setOpening] = useState(false);

  const onAnimationEnd = useCallback(() => {
    setOpening(false);
    navigation.goBack();
  }, [navigation]);

  const openBox = useCallback(() => {
    setOpening(true);
  }, []);

  const rotate = useSharedValue(0);
  const style = useAnimatedStyle(() => ({
    transform: [
      {
        rotate: `${rotate.value}deg`,
      },
    ],
  }));

  useEffect(() => {
    // preload open animation
    animations.mysteryBoxOpen();
  }, []);

  useEffect(() => {
    rotate.value = withRepeat(
      withTiming(360, { duration: 8000, easing: Easing.linear }),
      -1,
    );
  }, [rotate]);

  useEffect(() => {
    if (!isMobile) {
      const timeout = setTimeout(() => {
        setShowAnimation(true);
      }, 500);

      return () => clearTimeout(timeout);
    }
  }, [isMobile]);

  const screenBGColor = useBreakpointProp<BackgroundTokens>({
    mobile: 'backdropSecondary',
    tablet: 'transparent',
    desktop: 'transparent',
  });

  return (
    <Screen
      paddingHorizontal="space-0"
      paddingBottom="safe-area-inset-bottom"
      backgroundColor={screenBGColor}
    >
      <Box
        height="100%"
        justifyContent="space-between"
        position="relative"
        alignItems={{ mobile: undefined, tablet: 'center', desktop: 'center' }}
      >
        <Box alignItems="center" position="relative">
          <Box animatedStyle={style}>
            <Image
              name="shop.mysteryBoxFlare"
              height={500}
              aspectRatio={1}
              opacity={0.6}
              pointerEvents="none"
            />
          </Box>
          <Box position="absolute" top="-space-200">
            {showAnimation ? (
              <AnimationPlayer
                source={
                  opening
                    ? animations.mysteryBoxOpen
                    : animations.mysteryBoxPending
                }
                loop={opening ? false : true}
                onComplete={opening ? onAnimationEnd : undefined}
                sizeX={360}
                sizeY={360}
              />
            ) : null}
          </Box>
        </Box>
        <Button
          variant="primary"
          locNS="shop"
          locKey="shopMisteryBoxOpenCta"
          onPress={openBox}
          loading={opening}
          margin="space-600"
          position="relative"
          top={{
            mobile: 'space-0',
            tablet: '-space-3000',
            desktop: '-space-3000',
          }}
        />
      </Box>
    </Screen>
  );
}

export default memo(ShopMysteryBoxScreen);
